export const QTYPE_TEXT = 'simple';
export const QTYPE_MULTI_CHOICE = 'multiple-choice';
export const QTYPE_MULTI_ANSWER = 'multiple-answer';
export const QTYPE_NUMBER = 'number';
export const QTYPE_CAMERA = 'camera';
export const QTYPE_PRACTICAL = 'practical';
export const QTYPE_P_NUMBER = 'number';
export const QTYPE_P_TEXT = 'text';
export const QTYPE_P_BOOL = 'boolean';
